import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Check, Pencil } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmt = (n) => (n ?? 0).toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// % del resultado de blackjack que le corresponde al club (default 30%).
export const bjPorcentaje = (cierre) =>
  cierre.blackjack_porcentaje === undefined || cierre.blackjack_porcentaje === null
    ? 30 : Number(cierre.blackjack_porcentaje);

// Aplica con signo: si el blackjack dio pérdida, el club asume ese mismo % de la pérdida.
export const bjValor = (cierre) =>
  Math.round((cierre.blackjack_resultado || 0) * bjPorcentaje(cierre)) / 100;

export const bjDetalle = (cierre) =>
  `Apuestas ${fmt(cierre.bj_apuestas)} + Pagos ${fmt(cierre.bj_pagos)} = ` +
  `Resultado ${fmt(cierre.blackjack_resultado)} · ${bjPorcentaje(cierre)}% para el club = ${fmt(bjValor(cierre))}`;

export const BlackjackCell = ({ cierre, onSaved }) => {
  const [editando, setEditando] = useState(false);
  const [pct, setPct] = useState(bjPorcentaje(cierre));
  const valor = bjValor(cierre);

  const guardar = async () => {
    try {
      await axios.put(`${API}/poker/consolidacion/porcentajes-blackjack`,
        { club_id: cierre.club_id, porcentaje: Number(pct) });
      setEditando(false);
      toast.success(`Blackjack: ${pct}% para ${cierre.club_name}`);
      onSaved?.();
    } catch (e) {
      toast.error('No se pudo guardar el porcentaje de blackjack');
    }
  };

  return (
    <div className="flex items-center justify-end gap-1" title={bjDetalle(cierre)}
      data-testid={`blackjack-cell-${cierre.club_id}`}>
      <span className={valor < 0 ? 'text-red-600 dark:text-red-400' : ''}>{fmt(valor)}</span>
      {editando ? (
        <>
          <input type="number" min="0" max="100" value={pct} autoFocus
            onChange={(e) => setPct(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && guardar()}
            className="w-12 px-1 text-xs border border-amber-400 rounded text-right dark:bg-gray-800"
            data-testid={`blackjack-pct-input-${cierre.club_id}`} />
          <button onClick={guardar} className="text-emerald-600 hover:text-emerald-800"
            data-testid={`blackjack-pct-save-${cierre.club_id}`}>
            <Check className="w-3 h-3" />
          </button>
        </>
      ) : (
        <button onClick={() => { setPct(bjPorcentaje(cierre)); setEditando(true); }}
          className="text-[10px] text-gray-400 hover:text-amber-600 flex items-center gap-0.5"
          title="Editar el % del blackjack de este club"
          data-testid={`blackjack-pct-btn-${cierre.club_id}`}>
          {bjPorcentaje(cierre)}% <Pencil className="w-2.5 h-2.5" />
        </button>
      )}
    </div>
  );
};
